import styled from 'styled-components';
import { Poppins } from 'src/common';

export const Div = styled.div`
  .radio-row {
    display: flex;
    align-items: center;
    grid-gap: 11px;
    margin-bottom: 11px;
    user-select: none;
  }
`;

// Wider variant of `.scenarios-switch__title` (was an inline width override of the host modal's 200px rule).
export const WideSwitchTitle = styled(Poppins)`
  width: 300px;
`;
